import { render, staticRenderFns } from "./SummaryStats.vue?vue&type=template&id=61029503"
import script from "./SummaryStats.vue?vue&type=script&lang=js"
export * from "./SummaryStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports